// LOADER ************************************************************************************
/*********************************************************************************************
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
 */
const mmLoadThis = (elem) => elem.classList.add("mm-loading");

// MEGAMENU **********************************************************************************
/*********************************************************************************************
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow) => {
	document.querySelectorAll(classElemsToHide).forEach((elem) => (elem.style.display = "none"));
	document.querySelector(classElemToShow).style.display = "grid";
};

/*********************************************************************************************
 * Adjust the position of the mega menu based on the header height.
 *
 */
const getMegaMenuPosition = () => {
	const header = document.querySelector("[data-mm-header]");
	if (!header) return;

	const headerHeight = header.offsetHeight;
	document.querySelectorAll("[data-megamenulink]").forEach((menuElem) => {
		const megaMenu = menuElem.nextElementSibling;
		if (megaMenu?.hasAttribute("data-megamenu")) {
			megaMenu.style.top = `${headerHeight - 1}px`;
		}
	});
};

// BACKGROUND FILTER *************************************************************************
/*********************************************************************************************
 * Add background filter on hover over mega menu links.
 *
 */
const hoverBgFilter = () => {
	const header = document.querySelector("[data-mm-header]");
	const searchContainer = document.querySelector("[data-search-container]");
	const megaMenuLinks = document.querySelectorAll("[data-megamenulink]");
	const menuLinks = document.querySelectorAll("[data-menulink]");
	const filter = document.querySelector(".mm-menu-search-overlay");
	const cart = document.querySelector("[data-cart-filter]");

	if (!header || !filter || !cart) return;

	const toggleFilter = (show) => {
		filter.classList.toggle("mm-active", show);
	};

	megaMenuLinks.forEach((link) => {
		// Trouve le mega-menu associé (frère direct)
		const megaMenu = link.nextElementSibling;
		// Quand la souris entre sur le lien ou le mega-menu, on affiche le filtre
		[link, megaMenu].forEach(el => {
			if (el) {
				el.addEventListener("mouseenter", () => toggleFilter(true));
				el.addEventListener("mouseleave", () => toggleFilter(false));
			}
		});
	});

	header.addEventListener("mouseleave", () => {
		if ((!searchContainer || !searchContainer.classList.contains("mm-open")) && !cart.classList.contains("mm-dc-is-open")) {
			toggleFilter(false);
		}
	});
};

/*********************************************************************************************
 * Show background filter.
 *
 */
// const showBgFilter = (zIndex) => {
// 	const filter = document.querySelector("[data-filter]");
// 	if (!filter) return;
// 	filter.classList.add("active");
// 	if (zIndex) filter.style.zIndex = zIndex;
// };

const showMenuMobileFilter = () => {
	const menuMobileFilter = document.querySelector(".mm-filter-menu-mobile")
	if (!menuMobileFilter) return;
	menuMobileFilter.classList.add("mm-active")
}

const showMenuSearchOverlay = () => {
	const menuSearchOverlay = document.querySelector(".mm-menu-search-overlay")
	if (!menuSearchOverlay) return;
	menuSearchOverlay.classList.add("mm-active")
}

/*********************************************************************************************
 * Hide background filter.
 *
 */
const hideBgFilter = () => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	setTimeout(() => filter.style.removeProperty("z-index"), 700);
	filter.classList.remove("active");
};

const hideMenuMobileFilter = () => {
	const menuMobileFilter = document.querySelector(".mm-filter-menu-mobile")
	if (!menuMobileFilter) return;
	menuMobileFilter.classList.remove("mm-active")
}

const mmHideMenuSearchOverlay = () => {
	const menuSearchOverlay = document.querySelector(".mm-menu-search-overlay")
	if (!menuSearchOverlay) return;
	menuSearchOverlay.classList.remove("mm-active")
}

// EXTERNAL LINK *****************************************************************************
/*********************************************************************************************
 * Open external links in a new tab unless it's the consent modale.
 *
 */
const externalLink = () => {
	document.querySelectorAll("a:not(.consent-wrapper)").forEach((link) => {
		if (link.hostname !== window.location.hostname) {
			link.target = "_blank";
			link.rel = "noreferrer noopener";
		}
	});
};

// MENU MOBILE *******************************************************************************
/*********************************************************************************************
 * Toggle the mobile menu.
 *
 */
const mmMobileMenu = () => {
	if (window.innerWidth > 768) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		// mobileMenuSecondary: document.querySelector("[data-menu-sublinks]"),
		headerMenu: document.querySelector("[data-mm-header]"),
		html: document.querySelector("html")
	};
	const announcementBar = document.querySelector(".mm-section-announcement-bar")

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, mobileMenuSecondary, headerMenu, html } = elements;

	const headerHeight = headerMenu.offsetHeight;
	const headerMenuTop = headerMenu.getBoundingClientRect().top;
	const topPosition = `${headerHeight + headerMenuTop}px`;
	const heightCalc = `calc(var(--doc-height) - ${topPosition})`;
	[header, icon, mobileMenu].forEach((el) => el.classList.toggle("mm-open"));
	html.classList.add("stop-scrolling");

	Object.assign(mobileMenu.style, { top: topPosition, height: heightCalc });
	// mobileMenuSecondary.style.height = heightCalc;

	if (announcementBar) {
		announcementBar.style.zIndex = "unset";
	}

	showMenuMobileFilter();
};

/*********************************************************************************************
 * Close the mobile menu.
 *
 */
const mmCloseMobileMenu = () => {
	if (window.innerWidth > 768) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		html: document.querySelector("html"),
	};
	const announcementBar = document.querySelector(".mm-section-announcement-bar")

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, html } = elements;

	[header, icon, mobileMenu].forEach((el) => el.classList.remove("mm-open"));
	html.classList.remove("stop-scrolling");

	setTimeout(function() {
		if (announcementBar) {
			announcementBar.style.zIndex = "20";
		}
	}, 500);

	hideMenuMobileFilter();
};

/*********************************************************************************************
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowNext = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.add("mm-mobile-menu-elem-slided");
};

/*********************************************************************************************
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowPrev = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.remove("mm-mobile-menu-elem-slided");
};

// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');

	dropWrappers.forEach((item) => {
		item.addEventListener("click", function () {
			dropWrappers.forEach((el) => {
				if (el !== this) {
					el.classList.remove("active");
					if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
				}
			});

			this.classList.toggle("active");
			const content = this.nextElementSibling;

			if (content) {
				content.style.maxHeight = this.classList.contains("active") ? `${content.scrollHeight}px` : null;
			}
		});
	});
};

// SEARCH ************************************************************************************
/*********************************************************************************************
 * Show the search bar and related UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
const mmShowSearch = () => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;

	html.classList.add("stop-scrolling");
	search.classList.add("mm-open");
	showMenuSearchOverlay();

	setTimeout(() => searchInput.focus(), 1000);

	document.getElementById("predictive-search")?.addEventListener("touchstart", () => {
		setTimeout(() => searchInput.blur(), 500);
	});
};

/*********************************************************************************************
 * Hide the search bar and revert UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
 */
const mmHideSearch = (keepFilterActive = false, keepStopScrolling = false) => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;
	console.log(keepStopScrolling);
	if (!keepStopScrolling) {
		html.classList.remove("stop-scrolling");
	}
	search.classList.remove("mm-open");
	if (!keepFilterActive) hideBgFilter();

	searchInput.value = "";
	searchInput.dispatchEvent(new Event("input"));
	mmHideMenuSearchOverlay();
};

/*********************************************************************************************
 * Initialize parallax effect for slide images.
 *
 */
const mmInitParallax = () => {
	const images = document.querySelectorAll(".mm-slide-image");
	if (!images.length) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const slideImage = entry.target;
					const covers = slideImage.querySelectorAll(".mm-slide-image-cover");
					if (!covers.length) return;

					covers.forEach((cover) => {
						gsap.to(cover, {
							yPercent: 30,
							ease: "none",
							scrollTrigger: {
								trigger: slideImage,
								start: "top bottom",
								end: "bottom top",
								scrub: true,
							},
						});
					});

					observer.unobserve(slideImage);
				}
			});
		},
		{
			rootMargin: "0px 0px 200px 0px",
		}
	);

	images.forEach((image) => observer.observe(image));
};

/*********************************************************************************************
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll(".mm-video-lazy");
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== "true") {
			const source = video.querySelector("source");
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = "metadata";
			video.dataset.loaded = "true";

			video.load();
			video.play().catch((err) => console.warn("Auto-play failed:", err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === "true") {
			video.pause();
			video.currentTime = 0;
			video.dataset.loaded = "false";
		}
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const isDesktop = video.classList.contains("mm-desktop");
		const isMobileVideo = video.classList.contains("mm-mobile");

		const shouldPlay = (!isDesktop && !isMobileVideo) || (isDesktop && !isMobile) || (isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add("mm-video-loaded");
		} else {
			video.classList.remove("mm-video-loaded");
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: "50px 0px",
			threshold: 0.1,
		}
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains("mm-video-loaded")) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

/*********************************************************************************************
 * Set the document height CSS variable to the current window height.
 *
 */
const documentHeight = () => {
	document.documentElement.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

/*********************************************************************************************
 * Custom element for product recommendations
 *
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
						// Réinitialiser la wishlist pour les nouvelles cartes de produits
						if (window.wishlistManager) {
							window.wishlistManager.initButtons();
						}
					} else {
						const parentElement = this.closest(".mm-section");
						if (parentElement) {
							parentElement.style.display = "none";
						}
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);



// PRODUCT CARDS SLIDERS
function productCardsSlider() {
  var cards = document.querySelectorAll('.splide-product-card');

  cards.forEach(function(card) {
      // Vérifier si la carte est déjà initialisée
          var splide = new Splide(card, {
              type: 'slide',
              arrows: false,
              rewind: true,
              pagination: true,
              omitEnd: true,
              perPage: 1,
              perMove: 1,
              gap: 0,
              breakpoints: {
                  768: {
                      pagination: false,
                  }
              }
          });
          splide.mount();
  });
}

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	getMegaMenuPosition();
	hoverBgFilter();
	externalLink();
	handleDropdown();
	documentHeight();
	mmInitParallax();
	mmInitVideoLazy();
  productCardsSlider()
});

/*********************************************************************************************
 * Resized Listenner
 *
 */
window.addEventListener("resize", () => {
	getMegaMenuPosition();
	documentHeight();
});



/* Accordions */
function initAccordions() {
  const toggles = document.querySelectorAll('[data-accordion-toggle]');

  // Initialisation : masquer tous les "minus"
  toggles.forEach(toggle => {
    const [plusIcon, minusIcon] = toggle.querySelectorAll('svg');
    minusIcon.style.display = 'none';
  });

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      console.log('click')
      const targetId = toggle.getAttribute('data-accordion-toggle');
      const content = document.querySelector(`[data-accordion-content="${targetId}"]`);
      if (!content) return;

      const isOpen = content.classList.contains('open');

      // Fermer tous les contenus ET réinitialiser icônes
      document.querySelectorAll('[data-accordion-content]').forEach(el => {
        el.classList.remove('open');
        el.style.maxHeight = null;
      });
      toggles.forEach(t => {
        const [pIcon, mIcon] = t.querySelectorAll('svg');
        pIcon.style.display = 'inline';    // afficher plus
        mIcon.style.display = 'none';      // masquer moins
      });

      // Si on était fermé, on ouvre et on bascule l'icône
      if (!isOpen) {
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';

        const [plusIcon, minusIcon] = toggle.querySelectorAll('svg');
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'inline';
      }
    });
  });

  // Si vous avez des éléments à ouvrir au chargement
  const elemsToOpenOnLoad = document.querySelectorAll('[data-open-on-load]');
  elemsToOpenOnLoad.forEach(function(elem) {
    elem.dispatchEvent(new Event('click'));
  });
  
}

document.addEventListener('DOMContentLoaded', function () {
  initAccordions();
});


// PEDIMETRE
// Ouvrir la modale
function mmOpenPedimeter() {
	document.querySelector('.mm-surface-modale').classList.add('mm-modal-is-open');
	document.querySelector('html').classList.add('stop-scrolling');
}
// Fermer la modal
function mmClosePedimeter() {
	document.querySelector('.mm-surface-modale').classList.remove('mm-modal-is-open');
	document.querySelector('html').classList.remove('stop-scrolling');
}
